import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  errorMessage,
  wotcSurveyDataKey,
  wotcSurveyRoute,
} from '@features/wotc';
import axiosInstance from '@server/axiosInstance';

type useGetWotcSurveyProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useGetWotcSurvey = ({
  setErrorText,
}: useGetWotcSurveyProps) => {
  const {
    data: wotcSurveyData,
    isFetching: isLoadingWotcSurveyData,
    refetch: getWotcSurveyData,
  } = useQuery({
    queryKey: [wotcSurveyDataKey],
    queryFn: () => {
      const params = new URLSearchParams();


      return axiosInstance
        .get(wotcSurveyRoute, { params })
        .then((res) => res.data);
    },
    onSuccess: (data) => {
      if (data.object) {
        setErrorText('');
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return {
    getWotcSurveyData,
    wotcSurveyData,
    isLoadingWotcSurveyData,
  };
};
